import { IState } from '../../store';

// TODO: Удалить флаг в CD-206466
export const selectIsNewbuildingBrokerEntryRedesignEnabled = (state: IState) =>
  state.featureToggle.isNewbuildingBrokerEntryRedesignEnabled;
